export default "__VITE_ASSET__C6H9Eel8__"